import React, { useEffect, useState, useRef, useCallback } from 'react';
import Layout from '../../Layout';
import { Link, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import './CustomerDetail.scss'
import InformationTab from './Tabs/HistoryInformation';
import { useParams, useNavigate } from 'react-router-dom';
import * as customerApi from '../../api/customer/customerApi';
import useToast from '../../hook/useToast';
import { getInfoAccount, IPermissionCustomer } from '../../api/groupPermission/groupPermissionApi';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { mixGetV2, mixPostV2 } from '../../services/mixin'
import PoolingDataHistoryCard from '../../pages/Customers/Tabs/PoolingDataHistoryCard';

const CustomerDetail: React.FC = () => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const warehouseId = queryParams.get('id')
  const dataMigration = queryParams.get('data_migration')
  const dataKey = queryParams.get('data_key')

  const isCareFeedback = location.state?.isCareFeedback ?? false
  const navigate = useNavigate()
  const pushToast = useToast();

  useEffect(() => {

    return (() => {
      setInfoCustomer(undefined)
    })
  }, []);
  const [infoCustomer, setInfoCustomer] = useState<customerApi.ICustomerDetail_V4>()
  const [permissionCustomerView, setPermissionCustomerView] = useState<IPermissionCustomer>()
  const gInfoCustomer = async () => {
    const result = await customerApi.getInfoCustomer(Number(id))
    if (result?.status) {
      setInfoCustomer(result.data)
    } else {
      pushToast(result?.message, "error")

    }
  }

  //------------------------------------------------
  const [stData, setStData] = useState({
    detail: {
      take_cares: [],
      customer: {},
      car_used: [],
      history_buys: [],
      cars_dang_su_dung: [],
      cars_so_huu: [],
      nguoi_lien_he: [],
      ban_hang_dich_vu: [],
      ho_tro_khieu_nai: [],
      khao_sat_khach_hang: [],
      ban_hang: [],
      dich_vu: [],
    },
    col: [],
    jsonData: {},
    idUser: 0,
  });
  const [loading, setLoading] = useState(false);
  const isFetchingDetail = useRef(false);
  const isFetchingCols = useRef(false);

  const getDetail = useCallback(async (id: string) => {
    if (isFetchingDetail.current) return;

    isFetchingDetail.current = true;
    setLoading(true);
    try {
      const res = await mixPostV2('/api/v1/be/warehouse_processe/show_v2', {
        warehouse_id_origin: id,
        data_migration: dataMigration,
        data: dataKey,
      });
      if (res.status) {
        setStData(prev => ({ ...prev, detail: res.data }));
      } else {
       navigate('/*');
      }
    } finally {
      setLoading(false);
      isFetchingDetail.current = false;
    }
  }, []);

  useEffect(() => {
    if (id) {
      getDetail(id);
    }
  }, [id, getDetail]);

  // Column Data
  const user = useSelector(selectorInfoUser);
  useEffect(() => {
    let ignore = false;
    async function getcolumn() {
      const [res] = await Promise.all([
        mixGetV2('/api/v1/be/source_column_warehouses?is_active=1'),
      ]);
      if (!ignore && res.status) {
        const temp = [] as any
        res.data.items.map((val: any) => {
          const listSourceIds = [] as any
          val.params_key.map((val: any) => {
            listSourceIds.push(val.source_id)
            return true
          })
          temp.push({ ...val, source_ids: listSourceIds })
          return true
        })
        setStData(prev => ({ ...prev, idUser: Number(user.id) || 0, col: temp }));
      }
    }
    getcolumn();
    return () => { ignore = true; }
    // eslint-disable-next-line
  }, [user.id]);

  return (
    <Layout contentClassName='customer-detail-content'>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: <Link to="/customer/list">Khách hàng</Link>, },
          { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link>, },

          { title: <Link to="/customer/pooling-data/history">Lịch sử</Link>, },
          { title: 'Thông tin khách hàng', },
        ]}
        title='Thông tin khách hàng'
        backLink={isCareFeedback ? '/analysis-report/vip-customer-care' : '/customer/pooling-data/history'}
      />

      <Tabs
        defaultActiveKey={isCareFeedback ? 'care-feedback' : "information"}
        items={
          [
            {
              label: 'Thông tin',
              key: 'information',
              children:
                <InformationTab
                  value={{ ...stData }}
                  infoCustomer={infoCustomer}
                  permissionCustomerView={permissionCustomerView}
                  onChange={(data, type) => {
                    if (type === 'newDataJson') {
                      setStData(prev => ({ ...prev, jsonData: data }));
                    }
                  }}
                />,
            },
            {
              label: <div className='d-flex align-center gap-1'>{` Tất cả`}
                {/* <span className='w-38-px h-5 text-F5222D bg-FFF1F0 rounded-100-px flex align-center justify-center'>
                  {stData.detail?.take_cares.length > 0 ? stData.detail?.take_cares.length : 0}
                </span> */}
              </div>,
              key: 'care-feedback',
              children:
                <PoolingDataHistoryCard
                  value={{ ...stData }}
                  title='Danh sách tất cả'
                  nameTableCache="TbCacheHistorybao_duong_xe"
                  listData={stData.detail?.take_cares ?? []}
                  onChange={(data, type) => {
                    if (type === 'newDataJson') {
                      setStData(prev => ({ ...prev, jsonData: data }));
                    }
                  }}
                />,
            },
            {
              label: <div className='d-flex align-center gap-1'>{`Bán hàng / Dịch vụ`}
                {/* <span className='w-38-px h-5 text-F5222D bg-FFF1F0 rounded-100-px flex align-center justify-center'>
                  {stData.detail?.ban_hang_dich_vu.length > 0 ? stData.detail?.ban_hang_dich_vu.length : 0}
                </span> */}
              </div>,
              key: 'banhang_dichvu',
              children:
                <>
                  <PoolingDataHistoryCard
                    value={{ ...stData }}
                    title='Danh sách bán hàng'
                    nameTableCache="TbCacheHistorybanhang_dichvu"
                    listData={stData.detail?.ban_hang ?? []}
                    onChange={(data, type) => {
                      if (type === 'newDataJson') {
                        setStData(prev => ({ ...prev, jsonData: data }));
                      }
                    }}
                  />

                  <PoolingDataHistoryCard
                    value={{ ...stData }}
                    title='Danh sách dịch vụ'
                    nameTableCache="TbCacheHistorybanhang"
                    listData={stData.detail?.dich_vu ?? []}
                    onChange={(data, type) => {
                      if (type === 'newDataJson') {
                        setStData(prev => ({ ...prev, jsonData: data }));
                      }
                    }}
                  />
                </>
              ,
            },
            {
              label: <div className='d-flex align-center gap-1'>{`Hỗ trợ / Khiếu nại`}
                {/* <span className='w-38-px h-5 text-F5222D bg-FFF1F0 rounded-100-px flex align-center justify-center'>
                  {stData.detail?.ho_tro_khieu_nai.length > 0 ? stData.detail?.ho_tro_khieu_nai.length : 0}
                </span> */}
              </div>,
              key: 'hotro_khieunai',
              children:
                <PoolingDataHistoryCard
                  value={{ ...stData }}
                  title='Danh sách hỗ trợ / khiếu nại'
                  nameTableCache="TbCacheHistoryhotro_khieunai"
                  listData={stData.detail?.ho_tro_khieu_nai ?? []}
                  onChange={(data, type) => {
                    if (type === 'newDataJson') {
                      setStData(prev => ({ ...prev, jsonData: data }));
                    }
                  }}
                />,
            },
            // {
            //   label: <div className='d-flex align-center gap-1'>{`CSKH`}
            //     <span className='w-38-px h-5 text-F5222D bg-FFF1F0 rounded-100-px flex align-center justify-center'>
            //       {stData.detail?.take_cares.length > 0 ? stData.detail?.take_cares.length : 0}
            //     </span>
            //   </div>,
            //   key: 'cskh',
            //   children:
            //     <PoolingDataHistoryCard
            //       value={{ ...stData }}
            //       title='Danh sách cskh'
            //       nameTableCache="TbCacheHistorycskh"
            //       listData={stData.detail?.take_cares ?? []}
            //       onChange={(data, type) => {
            //         if(type === 'newDataJson') {
            //           setStData(prev => ({ ...prev, jsonData: data }));
            //         }
            //       }}
            //     />,
            // },
            {
              label: <div className='d-flex align-center gap-1'>{`Khảo sát`}
                {/* <span className='w-38-px h-5 text-F5222D bg-FFF1F0 rounded-100-px flex align-center justify-center'>
                  {stData.detail?.khao_sat_khach_hang.length > 0 ? stData.detail?.khao_sat_khach_hang.length : 0}
                </span> */}
              </div>,
              key: 'khaosat',
              children:
                <PoolingDataHistoryCard
                  value={{ ...stData }}
                  title='Danh sách khảo sát'
                  nameTableCache="TbCacheHistorykhaosat"
                  listData={stData.detail?.khao_sat_khach_hang ?? []}
                  onChange={(data, type) => {
                    if (type === 'newDataJson') {
                      setStData(prev => ({ ...prev, jsonData: data }));
                    }
                  }}
                />,
            },
            // {
            //   label: 'Nguồn',
            //   key: 'source',
            //   children: <SourceTab />,
            // },
          ]
        }
        className='rs-tabs'
      />
    </Layout>
  );
}

export default CustomerDetail;
